[
  {
    "code": "CI-06",
    "name": "18 Montagnes (Région des)"
  },
  {
    "code": "CI-16",
    "name": "Agnébi (Région de l')"
  },
  {
    "code": "CI-17",
    "name": "Bafing (Région du)"
  },
  {
    "code": "CI-09",
    "name": "Bas-Sassandra (Région du)"
  },
  {
    "code": "CI-10",
    "name": "Denguélé (Région du)"
  },
  {
    "code": "CI-18",
    "name": "Fromager (Région du)"
  },
  {
    "code": "CI-02",
    "name": "Haut-Sassandra (Région du)"
  },
  {
    "code": "CI-07",
    "name": "Lacs (Région des)"
  },
  {
    "code": "CI-01",
    "name": "Lagunes (Région des)"
  },
  {
    "code": "CI-12",
    "name": "Marahoué (Région de la)"
  },
  {
    "code": "CI-19",
    "name": "Moyen-Cavally (Région du)"
  },
  {
    "code": "CI-05",
    "name": "Moyen-Comoé (Région du)"
  },
  {
    "code": "CI-11",
    "name": "Nzi-Comoé (Région)"
  },
  {
    "code": "CI-03",
    "name": "Savanes (Région des)"
  },
  {
    "code": "CI-15",
    "name": "Sud-Bandama (Région du)"
  },
  {
    "code": "CI-13",
    "name": "Sud-Comoé (Région du)"
  },
  {
    "code": "CI-04",
    "name": "Vallée du Bandama (Région de la)"
  },
  {
    "code": "CI-14",
    "name": "Worodougou (Région du)"
  },
  {
    "code": "CI-08",
    "name": "Zanzan (Région du)"
  }
]